import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PhoneInputField.scss";

const PhoneInputField = ({
  phone,
  setPhone,
  resetKey,
  countryCode,
  setCountryCode,
  setCountryName,
}) => {
  return (
    <div className="phone-field">
      <PhoneInput
        key={resetKey}
        country={"in"}
        value={phone}
        onChange={(value, data) => {
          setPhone(value);
          setCountryCode(data.countryCode);
          setCountryName(data.name);
        }}
        countryCodeEditable={false}
        enableSearch={true}
        disableSearchIcon={true}
      />
    </div>
  );
};

export default PhoneInputField;
